const { camelCase, snakeCase } = require("change-case");

// If updated, need to add/remove corresponding SVG @ src/react/App/SVG

const machineNamePrefix = "social_media_";

const configs = [
  {
    label: "amazon",
    link: (handle) => "https://www.amazon.com/" + handle,
  },
  {
    label: "buy me a coffee",
    link: (handle) => "https://www.buymeacoffee.com/" + handle,
  },
  {
    label: "facebook",
    link: (handle) => "https://www.facebook.com/" + handle,
  },
  {
    label: "goodreads",
    link: (handle) => "https://www.goodreads.com/author/show/" + handle,
  },
  {
    label: "instagram",
    link: (handle) => "https://www.instagram.com/" + handle,
  },
  {
    label: "ko-fi",
    link: (handle) => "https://ko-fi.com/" + handle,
  },
  {
    label: "medium",
    link: (handle) =>
      "https://www.medium.com/" +
      (handle.startsWith("@") ? handle : "@" + handle),
  },
  {
    label: "patreon",
    link: (handle) => "https://www.patreon.com/" + handle,
  },
  {
    label: "pinterest",
    link: (handle) => "https://www.pinterest.com/" + handle,
  },
  {
    label: "reddit",
    link: (handle) =>
      handle.startsWith("u/") || handle.startsWith("user/")
        ? "https://www.reddit.com/" + handle
        : "https://www.reddit.com/u/" + handle,
  },
  {
    label: "soundcloud",
    link: (handle) => "https://soundcloud.com/" + handle,
  },
  {
    label: "spotify",
    link: (handle) =>
      handle.startsWith("u/") || handle.startsWith("user/")
        ? "https://open.spotify.com/" + handle
        : "https://open.spotify.com/user/" + handle,
  },
  {
    label: "tumblr",
    link: (handle) => "https://" + handle + ".tumblr.com",
  },
  {
    label: "twitter",
    link: (handle) => "https://twitter.com/" + handle,
  },
  {
    label: "youtube",
    link: (handle) =>
      handle.startsWith("c/") || handle.startsWith("channel/")
        ? "https://www.youtube.com/" + handle
        : "https://www.youtube.com/channel/" + handle,
  },
].map((config) => ({
  key: camelCase(config.label),
  machine_name: machineNamePrefix + snakeCase(config.label),
  ...config,
}));

const machineNames = configs.map((config) => config.machine_name);

const link = configs.reduce(
  (reducer, config) => ({ ...reducer, [config.key]: config.link }),
  {}
);

function get(id) {
  for (let config of configs)
    if (config.key === id || config.label === id || config.machine_name === id)
      return config;
}

const socialMedia = { configs, machineNamePrefix, machineNames, link, get };

module.exports = socialMedia;
